// import gsap from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';
import normalizeWheel from 'normalize-wheel';

window.evolveSliderInit = function evolveSliderInit() {
  if (window.innerWidth > 1024) {
    const evolveSec = document.querySelector('.evolve-sec');
    const evolveGallery = document.querySelector('.evolve-sec__gallery');
    const evolveSecContainer = document.querySelector('.evolve-sec-container');

    const isChrome =
      /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

    if (isChrome && window.innerWidth >= 1025) {
      evolveSecContainer.classList.add('is-chrome');
    }

    if (evolveSec && evolveGallery) {
      const evolveSlides = document.querySelector('.evolve-sec__slides');
      const evolveSlidesArr = document.querySelectorAll('.evolve-sec__slide');
      const evolveGallerySlidesArr = evolveGallery.querySelectorAll(
        '.evolve-sec__gallery-slide'
      );
      const slides = gsap.utils.toArray('.evolve-sec__slide');

      let currentIndex = 0;
      let lastSnapTarget = 0;
      let slideWidth = evolveSec.getBoundingClientRect().width;

      evolveSlides.style.width = `${slides.length * slideWidth}px`;
      slides.forEach((slide, index) => {
        slide.style.width = `${slideWidth}px`;
        slide.style.position = 'absolute';
        slide.style.left = `${index * slideWidth}px`;
        slide.style.top = '0';
        slide.style.height = '100vh';
      });

      evolveGallerySlidesArr.forEach((slide, index) => {
        slide.style.transition = 'transform 0.4s ease';
        slide.style.transform =
          index === 0 ? 'translateX(0%)' : 'translateX(100%)';
      });

      function applyGalleryState(targetIndex) {
        const prev = targetIndex - 1;

        evolveGallerySlidesArr.forEach((slide, index) => {
          if (index === targetIndex || index === prev) {
            slide.style.transform = 'translateX(0%)';
          } else {
            slide.style.transform = 'translateX(100%)';
          }

          slide.classList.toggle(
            'is-prev',
            index === prev && index !== slides.length - 1
          );
        });

        evolveSlidesArr.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === targetIndex);
        });

        currentIndex = targetIndex;
        lastSnapTarget = targetIndex;
      }

      applyGalleryState(0);

      let lastScrollY = 0;
      let scrollDirection = 'down';

      const updateScrollDirection = throttle(() => {
        const currentScrollY = window.scrollY;
        scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up';
        lastScrollY = currentScrollY;
      }, 100);

      window.addEventListener('scroll', updateScrollDirection, {
        passive: true,
      });

      // Добавляем переменные для контроля скорости скролла
      let scrollVelocity = 0;
      let lastScrollTime = Date.now();

      const updateScrollVelocity = () => {
        const currentTime = Date.now();
        const currentScrollY = window.scrollY;
        const timeDiff = currentTime - lastScrollTime;
        const scrollDiff = Math.abs(currentScrollY - lastScrollY);

        scrollVelocity = timeDiff > 0 ? scrollDiff / timeDiff : 0;
        lastScrollTime = currentTime;
      };

      window.addEventListener('scroll', updateScrollVelocity, {
        passive: true,
      });

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: evolveSec,
          pin: true,
          start: 'top top',
          scrub: 0.33,
          normalizeScroll: true,
          pinSpacing: true,
          preventOverlaps: true,
          invalidateOnRefresh: true,
          snap: {
            snapTo: (progress) => {
              const slideProgress = progress * (slides.length - 1);
              return Math.round(slideProgress) / (slides.length - 1);
            },
            duration: {
              min: 0.05,
              max: 0.1,
            },
            delay: 0.1,
          },
          end: () => '+=' + (evolveSlides.offsetWidth - window.innerWidth),
        },
      });

      tl.to(slides, {
        x: -slideWidth * (slides.length - 1),
        ease: 'none',
      });

      let callback = function (entries) {
        entries.forEach((entry) => {
          const slide = entry.target;
          const slideIndex = slides.indexOf(slide);

          if (entry.isIntersecting && slideIndex !== -1) {
            if (slideIndex !== currentIndex) {
              applyGalleryState(slideIndex);
            }
          }
        });
      };

      let resizeTimeout;
      const resizeObserver = new ResizeObserver((entries) => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          slideWidth = evolveSec.getBoundingClientRect().width;
          evolveSlides.style.width = `${slides.length * slideWidth}px`;
          slides.forEach((slide, index) => {
            slide.style.width = `${slideWidth}px`;
            slide.style.left = `${index * slideWidth}px`;
          });
          tl.invalidate();
        }, 200);
      });

      resizeObserver.observe(document.querySelector('body'));

      let observer = new IntersectionObserver(callback, {
        root: evolveSec,
        threshold: 0.7,
      });

      slides.forEach((slide) => observer.observe(slide));
    }
  }
};

function throttle(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

let evolveSwiperWr = document.querySelectorAll('.evolve-swiper-wr');
evolveSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    const evolveSliderTitlesArr = el.querySelectorAll(
      '.evolve-sec__slider-title'
    );

    let swiper = new Swiper(swiperEl, {
      modules: [Navigation],
      observer: true,
      observeParents: true,
      spaceBetween: 24,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      /*autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },*/
      autoplay: false,
    });

    lineTitlesFunc(evolveSliderTitlesArr);
  }
});

const evolveSecSlidesEl = document.querySelector('.evolve-sec__slides');
const evolveSecGalleryEl = document.querySelector('.evolve-sec__gallery');
const evolveSecSliderEl = document.querySelector('.evolve-sec__slider');

if (evolveSecSlidesEl) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          evolveSecSlidesEl.classList.add('is-add-animation-fade');
          evolveSecGalleryEl.classList.add('is-add-animation-fade');
          evolveSecSliderEl.classList.add('is-add-animation-fade');
        } else {
          evolveSecSlidesEl.classList.remove('is-add-animation-fade');
          evolveSecGalleryEl.classList.remove('is-add-animation-fade');
          evolveSecSliderEl.classList.remove('is-add-animation-fade');
        }
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -55% 0px',
      threshold: 0,
    }
  );

  setTimeout(() => {
    observer.observe(evolveSecSlidesEl);
  }, 300);
}
